export default [
  {
    path: '/faq',
    name: 'Faq',
    component: () => import('@/modules/FAQ/FAQPage.vue'),
  },
]
